import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import Services from "./components/main/services";
import About from "./components/main/about";
import Contact from "./components/main/contact";
import Navbar from "./components/main/navbar";
import Home from "./components/main/home";
import ServicePage from './components/services/servicePage'
import Footer from "./utils/Footer";
import './App.css';

function App() {
  // Main layout used for the home/landing content
  const MainLayout = (
    <div className="App">
      <Navbar />
      <Home />
      <Services />
      <About />
      <Contact />
      <Footer />
    </div>
  )

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/services/:slug" element={<><Navbar /><ServicePage /></>} />
          <Route path="/*" element={MainLayout} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
